<template>
  <DashboardContent>
    <DashboardPageLayout title="CBT Test Results">
      <div class="p-3">
        <!-- Header with back arrow -->
        <div class="flex items-center gap-3 mb-3">
          <Button size="small" icon="pi pi-arrow-left" label="Back to Tests" class="p-button-text" @click="goBack" data-testid="btn-cbt-results-back" />
        </div>

        <CBTResultTable :testId="testId" />
      </div>
    </DashboardPageLayout>
  </DashboardContent>
</template>

<script setup lang="ts">
import DashboardContent from '@/components/DashBoard/common/DashboardContent.vue';
import DashboardPageLayout from '@/components/DashBoard/common/DashboardPageLayout.vue';
import CBTResultTable from './CBTResultTable.vue';

const route = useRoute();
const router = useRouter();

const testId = route.params.testId as string;

function goBack() {
  // Navigate back to the CBT page with the 'manage-tests' tab active
  router.push({ name: 'admin-cbt', query: { tab: 'manage-tests' } });
}
</script>
